import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {Core} from "@core/core"
import {CoreBoot} from "@core/core-boot/core-boot";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        HttpClientModule
    ],
    providers: [
        CoreBoot,
        Core,
    ],
    exports: []
})
export class CoreModule {}
